<template>
  <v-card>
    <v-card-text>
      <v-overlay v-if="loader"> </v-overlay>
      <v-form @submit.prevent="checkForm">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="nm"
                label="Nombre de Actividad"
                :error-messages="errors.nombre"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="sr"
                label="Folio de Actividad"
                :error-messages="errors.folio"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row justify="end">
            <v-btn color="grey" @click="$emit('toggle', false)" class="mr-2"
              >Cancelar</v-btn
            >
            <v-btn color="success" type="submit">Guardar</v-btn>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: "ActividadesForm",
  components: {},
  props: ["edit", "dataEdit", "actividades"],
  data() {
    return {
      nm: "",
      sr: "",
      loader: false,
      errors: [],
      id: "",
    };
  },
  methods: {
    checkForm: function (e) {
      e.preventDefault();
      let valid = true;

      this.errors = [];

      if (!this.nm) {
        this.errors.nombre = "El nombre de la Actividad es obligatorio";
        valid = false;
      } else {
        this.errors.nombre = false;
      }

      if (!this.sr) {
        this.errors.folio = "El Folio de la Actividad es obligatorio";
        valid = false;
      } else if (
        this.$pgsHelper.getById(this.actividades, "sr", this.sr.toUpperCase())
      ) {
        this.errors.folio = "Folio de actividad ya existente";
        valid = false;
      } else {
        this.errors.folio = false;
        this.sr = this.sr.toUpperCase();
      }

      if (valid) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        // console.log(this.$data)
        this.$emit("successData", this.$data, doAction);
      }
    },
  },
  watch: {},
  beforeMount: function () {},
  mounted() {
    this.loader = false;
    if (this.edit) {
      this.id = this.dataEdit.id;
      this.nm = this.dataEdit.nm;
      this.sr = this.dataEdit.sr;
    }
  },
};
</script>
